var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloseModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2959 13.293C27.6864 12.9025 28.3194 12.9026 28.71 13.293C29.1005 13.6835 29.1005 14.3165 28.71 14.707L22.415 21.001L28.71 27.2949C29.1004 27.6854 29.1014 28.3194 28.7109 28.71C28.3204 29.1004 27.6864 29.1004 27.2959 28.71L21.001 22.415L14.707 28.71C14.3165 29.1003 13.6824 29.1004 13.292 28.71C12.9018 28.3195 12.9027 27.6854 13.293 27.2949L19.5869 21.001L13.293 14.707C12.9025 14.3165 12.9025 13.6835 13.293 13.293C13.6835 12.9025 14.3165 12.9025 14.707 13.293L21.001 19.5869L27.2959 13.293Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseModal);
export default __webpack_public_path__ + "static/media/icon_close_modal.4430f44489125dee3f25196e4009185c.svg";
export { ForwardRef as ReactComponent };